import { RessourceModel } from './ressource.model';
import { SituationProfessionnelleModel } from './situation-professionnelle.model';

/**
 * 
 */
export class PersonneModel {

    enfantACharge: boolean;
    role: string;
    indemniseChomageMoisPrecedent: boolean;
    enActivite: boolean;
    estAuChomage: boolean;
    public flgDemandeur: boolean;

    ressourceList: RessourceModel[];
    situationProfessionnelleList: SituationProfessionnelleModel[];
}
